import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './HomeIcons.css';

export default class HomeIcons extends Component {
    constructor(props) {
        super(props);
    }

    getGeneratedData(itemList) {
        return itemList.map((item) => (
            <li className='list-items' key={item.id}>
                {this.renderItem(item)}      
            </li>
        ));

    }

    renderItem(item)
    {
        var docLink = "";
        if (item.downloadType == "1") {
            {/*eslint-disable-next-line react/jsx-no-target-blank*/ }
            docLink = <a href={process.env.BASE_URL + item.path} target="_blank" className="home-link">{item.name}</a>
        }
        else {
            docLink = <Link to={item.path} className="home-link">{item.name}</Link>
        }
        return docLink;
    }

    render() {
        return (
            <div className="icons-container">
                <div className="home-content-heading">
                    {this.props.content.title}
                </div>
                <div className="icons-content">
                <img src={this.props.icon} alt='icon' className="large-info-icon" />
                    <div className="home-content">
                        <div className="home-content-list">
                            <ul>
                                {this.getGeneratedData(this.props.content.files)}
                            </ul>
                        </div>
                        <div className="home-nav-button" onClick={this.props.navToIntroduction}>{this.props.content.action}</div>
                    </div>
                </div>
            </div>
        );
    }
}

HomeIcons.propTypes = {
    content: PropTypes.object,
    navToIntroduction: PropTypes.func,
    icon: PropTypes.string
}